<template>
<!-- 拼团详情 -->
    <div class="el-card  pd20">
        <!-- add---新增 -->
        <div class="add-box">
            <el-button type="info" icon="el-icon-arrow-left"  @click="$router.go(-1)"  size="medium">返回拼团列表</el-button>
            <!--  --> 
            <div class="search">
                <el-select class="search-child" v-model="state" placeholder="请选择状态" clearable>
                    <el-option  label="成功" :value="1">成功</el-option>
                    <el-option  label="进行中" :value="0">进行中</el-option>
                    <el-option  label="失败" :value="2">失败</el-option>
                </el-select>
                <!--  -->
                <el-input class="search-child" v-model="nickname" placeholder="请输入团长名称"></el-input>
                <!-- 搜索 -->
                <el-button type="primary" class="search-child" @click="pullData" round  size="medium">搜索</el-button>
            </div>
            
        </div>
         <el-divider></el-divider>
        <!--  -->
        <div class="el-card  pd20 content">
            <el-table :data="list" border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="60" label="序号"></el-table-column>
                <el-table-column   label="团长名称">
                    <template slot-scope="scope">
                        <div class="userinfo">
                           <img class="headimgurl" :src="scope.row.headimgurl" alt="">{{scope.row.nickname}}
                        </div>
                        
                    </template>
                </el-table-column>
                <el-table-column prop="start_time" label="开团时间" > </el-table-column>
                <el-table-column prop="end_time" label="结束时间" > </el-table-column>
                <el-table-column prop="num" label="真实成团人数" > </el-table-column>
                <el-table-column  label="拼团情况" >
                    <template slot-scope="scope">
                        {{scope.row.num}}/{{scope.row.snum}}
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态"></el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { scrabble_scrabblelist } from "@/api/operating";
export default {
    data() {
        return{
            pages:{},
            list:[],
            // 
            state:null,
            nickname:'',
            obj:{}
        }
    },
    methods:{
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25,   //每页数量，默认25
                id:this.$route.query.id
            };
            if(String(this.state) && this.state != null){
                this.obj['state'] = this.state;
            }

            if(this.nickname){
                this.obj['nickname'] = this.nickname;
            }

            scrabble_scrabblelist(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.headimgurl{
    width: 100px;
    height: 100px;
}
.add-box{
    margin-bottom: 20px;
    display: flex;
}
.content{
    padding: 20px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.userinfo{
    display: flex;
    align-items: center;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.search{
    margin-left: auto;
    text-align: right;
}
.search-child{
    margin-left: 20px;
    width: auto;
}
</style>
